import React from "react";

export const EventPhoto = ({ photo, priority = false, showCaption = true }) => {
  if (!photo) return null;
  const { crop } = photo;

  // Reuse the original documentary photograph without re-encoding its pixels.
  const cropStyle = crop ? {
    width: `${(photo.sourceWidth / crop.width) * 100}%`,
    left: `${(-crop.x / crop.width) * 100}%`,
    top: `${(-crop.y / crop.height) * 100}%`,
  } : undefined;

  return (
    <figure className="news-photo">
      <div
        className={`news-photo-frame${crop ? " news-photo-crop" : ""}`}
        style={{ aspectRatio: crop ? `${crop.width} / ${crop.height}` : `${photo.sourceWidth} / ${photo.sourceHeight}` }}
      >
        <img
          src={photo.src}
          alt={photo.alt}
          width={photo.sourceWidth}
          height={photo.sourceHeight}
          style={cropStyle}
          loading={priority ? "eager" : "lazy"}
          decoding="async"
        />
      </div>
      {showCaption && photo.caption && <figcaption>{photo.caption}</figcaption>}
    </figure>
  );
};
